// Generated by ts-to-zod
import {z} from "zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineFloatingPositionSchema = z.union([
	z.literal("top"),
	z.literal("right"),
	z.literal("bottom"),
	z.literal("left"),
	z.literal("top-start"),
	z.literal("top-end"),
	z.literal("bottom-start"),
	z.literal("bottom-end"),
	z.literal("left-start"),
	z.literal("left-end"),
	z.literal("right-start"),
	z.literal("right-end"),
]);

export const mantineTooltipPropsSchema = z.strictObject({
	label: z.string().optional(),
	withArrow: z.boolean().optional(),
	position: mantineFloatingPositionSchema.optional(),
	withinPortal: z.boolean().optional(),
	color: z.string().optional(),
	radius: mantineSpacingSchema.optional(),
	multiline: z.boolean().optional(),
	zIndex: z.number().optional(),
});
